import { ApiCalendar, ApiCalendarProviders } from "@/types/calendar.types.ts";
import {
  ApiWorkflowTriggerScheduleEntityField,
  ApiWorkflowTriggerScheduleEntityType,
} from "@/types/workflows/workflow.base-enum.types.ts";
import { add, differenceInMinutes } from "date-fns";

export type MeetingDateDirection = "before" | "after";

export const meetingOffsetToDirection = (offsetDays: number): MeetingDateDirection =>
  offsetDays < 0 ? "before" : "after";

export const meetingDirectionToOffset = (direction: MeetingDateDirection, days: number): number =>
  direction === "before" ? -days : days;

export const meetingEntityTypeForField = (
  field: ApiWorkflowTriggerScheduleEntityField
): ApiWorkflowTriggerScheduleEntityType =>
  field === ApiWorkflowTriggerScheduleEntityField.date_start
    ? ApiWorkflowTriggerScheduleEntityType.time_off
    : ApiWorkflowTriggerScheduleEntityType.employee;

export const meetingTimeStringToDate = (time: string | null | undefined): Date | null => {
  if (!time) return null;
  const [hours, minutes] = time.split(":").map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
};

export const meetingDateToTimeString = (date: Date): string => {
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}:00`;
};

export const isMeetingConferenceAvailable = (
  calendar: Pick<ApiCalendar, "provider"> | null | undefined
): boolean => calendar?.provider === ApiCalendarProviders.google_calendar;

export const addMinutesToTimeString = (time: string, minutes: number): string => {
  const date = meetingTimeStringToDate(time);
  if (!date) return time;
  return meetingDateToTimeString(add(date, { minutes }));
};

export const durationBetweenTimeStrings = (start: string, end: string): number => {
  const startDate = meetingTimeStringToDate(start);
  const endDate = meetingTimeStringToDate(end);
  if (!startDate || !endDate) return 0;
  return differenceInMinutes(endDate, startDate);
};
